module.exports = __webpack_public_path__ + "media/images/signature-1e90640ddc1e04b595056ca52d218c1c.png";